import { useState } from 'react'
import { Select, TYPE } from 'baseui/select'
import { FormControl } from 'baseui/form-control'
import debounce from '@/shared/tools/debounce'
import { useTranslation } from 'react-i18next'
import getAPIConfig from '@/shared/tools/getAPIConfig'
import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'

const UserComboBox = ({ searchUsersUrl, onChange, value, formErrors }) => {
  const [localValue, setValue] = useState([])
  const [options, setOptions] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { t } = useTranslation()
  const { authTokenSession } = useSelector(selectAuthData)

  const getOptionLabel = ({ option }) => {
    return `${option.name} ${option.firstName} - ${option.email}`
  }

  /**
   * Fetch options asyncronously
   * @type {debounced}
   */
  const handleInputChange = debounce(async value => {
    if (!value) {
      return
    }

    setIsLoading(true)

    try {
      // to switch to get route path from BO route() fn
      const result = await fetch(
        `${searchUsersUrl}?role=user&search=${value}`,
        getAPIConfig({ method: 'GET', authTokenSession }),
      )
      const data = await result.json()

      setOptions(data.users)
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }, 400)

  return (
    <>
      <FormControl
        label={t('officesManagement:mcp_agent')}
        error={formErrors.mcp_agent_id ? formErrors.mcp_agent_id[0] : ''}
      >
        <Select
          options={options}
          valueKey='id'
          getOptionLabel={getOptionLabel}
          getValueLabel={getOptionLabel}
          placeholder={t('officesManagement:mcp_agent')}
          maxDropdownHeight='300px'
          type={TYPE.search}
          onChange={({ value }) => {
            setValue(value)
            onChange(value)
          }}
          closeOnSelect={false}
          isLoading={isLoading}
          onInputChange={event => {
            const target = event.target
            handleInputChange(target.value)
          }}
          value={value}
          filterOptions={option => option}
        />
      </FormControl>
    </>
  )
}

export default UserComboBox
